"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var useSummaryContext_1 = require("../../../../react/useSummaryContext");
var ContentLine_1 = require("../../../contentLine/ContentLine");
var Price_1 = require("../../../prices/price/Price");
var cashSummaryBlockStyles_1 = require("./cashSummaryBlockStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var PriceDisplayType_1 = require("../../../../../../../common/enum/PriceDisplayType");
var CashSummaryBlocks = function (_a) {
    var subtitle = _a.subtitle, prices = _a.prices, isMultiCurrency = _a.isMultiCurrency;
    var _b, _c;
    var style = cashSummaryBlockStyles_1.default();
    var _d = useSummaryContext_1.default().priceDisplay, primary = _d.primary, secondary = _d.secondary;
    return (<core_1.Box className={style.cashSummaryBlocks}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.title}>
            <Translation_1.default id={'financeSummary.header'}/>
          </core_1.Typography>}/>
      {subtitle && (<ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
              <Translation_1.default id={subtitle}/>
            </core_1.Typography>}/>)}
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id={'financeSummary.subtitle'} values={{
        total: (<>
                    <Price_1.default price={(_b = prices.totalPayable) === null || _b === void 0 ? void 0 : _b.basePrice} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={(_c = prices.totalPayable) === null || _c === void 0 ? void 0 : _c.currency} decimals={primary.decimalScale}/>
                    {isMultiCurrency && (<>
                        <core_1.Typography component="span" data-test="cash_price:divider" className={style.divider}>
                          <Translation_1.default id={'carDetails.label.or'}/>
                        </core_1.Typography>
                        <Price_1.default price={prices.secondaryTotalPrice.basePrice} priceDisplayType={PriceDisplayType_1.PriceDisplayType.SECONDARY} currency={prices.secondaryTotalPrice.currency} decimals={secondary.decimalScale}/>
                      </>)}
                  </>),
    }}/>
          </core_1.Typography>}/>
    </core_1.Box>);
};
exports.default = CashSummaryBlocks;
